import React from "react";
import PropTypes from 'prop-types';
import Badge from '@material-ui/core/Badge';
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

const ToolbarIcon = ({icon, badge, ...props}) => (
    <IconButton
        color="inherit"
        {...props}
    >
        <Badge
            badgeContent={badge}
            color="primary"
        >
            <Icon>{icon}</Icon>
        </Badge>
    </IconButton>
);

ToolbarIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    badge: PropTypes.number,
};

ToolbarIcon.defaultProps = {
    badge: 0,
};

export default ToolbarIcon;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Toolbar/Icon.jsx